import * as types from './mutation-types'

export default store => {
  let timeoutId = null
  store.subscribe(async mutation => {
    switch (mutation.type) {
      case 'menuDraftModule/' + types.CREATE_CATEGORY:
      case 'menuDraftModule/' + types.SET_CATEGORY_PROPERTIES:
      case 'menuDraftModule/' + types.UPDATE_CATEGORIES:
      case 'menuDraftModule/' + types.DELETE_CATEGORY:
      case 'menuDraftModule/' + types.CREATE_GROUP:
      case 'menuDraftModule/' + types.SET_GROUP_PROPERTIES: // SET_ITEM_PROPERTIES, CREATE_QUESTION, SET_QUESTION_PROPERTIES, CREATE_OPTION, SET_OPTION_PROPERTIES 最後都會呼叫這個
      case 'menuDraftModule/' + types.DELETE_GROUP:
      case 'menuDraftModule/' + types.CREATE_ITEM:
        store.dispatch('menuDraftModule/cleanDraft')
        store.commit('menuDraftModule/' + types.INCREASE_MODIFICATION_COUNT)
        clearTimeout(timeoutId)
        if (store.state.menuDraftModule.modificationCount % 20 === 0) {
          store.dispatch('menuDraftModule/saveDraft', store.state.menuDraftModule.currentDraft.variation)
        } else {
          timeoutId = setTimeout(() => {
            if (store.state.menuDraftModule.modificationCount !== 0) {
              store.dispatch('menuDraftModule/saveDraft', store.state.menuDraftModule.currentDraft.variation)
            }
          }, 10000)
        }
        break
      default:
    }
  })
}
